module.exports = __webpack_public_path__ + "img/empty-feed.5cf0d747.png";